import BackboneElement from './BackboneElement';
import CodeableConcept from './types/CodeableConcept';
import Money from './types/Money';
import merge from 'lodash/merge';

export default class ClaimResponseItemAdjudication extends BackboneElement {
    static __className = 'ClaimResponseItemAdjudication';

    __objectStructure = {
        category: CodeableConcept,
        reason: CodeableConcept,
        amount: Money,
        value: Number,
    };

    constructor(constructJson, className = 'ClaimResponseItem') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
